module.exports = __webpack_public_path__ + "media/src/images/favicon/android-chrome-384x384-6e37750798d78bac104c8fee5c14d0c4.png";